export const materialNameMap: Record<string, string> = {
  "경이로운 명예의 돌파석": "Glorious_Honor_Stone.png",
  "빛나는 지혜의 엘릭서": "Shining_Elixir_of_Wisdom.png",
  "쇠락의 눈동자": "Decaying_Eye.png",
  "광기의 나팔": "Madness_Horn.png",
  수호강석: "Guardian_Stone.png",
  "농축 돌파석": "Concentrated_Breakthrough_Stone.png",
  "수호석 결정": "Guardian_Stone_Crystal.png",
  "순환 돌파석": "Cycling_Breakthrough_Stone.png",
  "시련의 빛": "Light_of_Trial.png",
  "심화 돌파석": "Advanced_Breakthrough_Stone.png",
  "아그리스의 비늘": "Agrise_Scale.png",
  "알키오네의 눈": "Eye_of_Alcyone.png",
  "어둠의 불": "Fire_of_Darkness.png",
  "업화의 쐐기돌": "Searing_Spike.png",
  "욕망의 날개": "Wings_of_Desire.png",
  "운명의 돌": "Stone_of_Fate.png",
  "마수의 뼈": "Beast_Bone.png",
  "운명의 돌파석": "Breakstone_of_Fate.png",
  "운명의 수호석": "Guardian_Stone_of_Fate.png",
  "운명의 파괴석": "Destruction_Stone_of_Fate.png",
  "관조의 빛무리": "Contemplation_Light.png",
  "빛나는 지혜의 기운": "Radiant_Energy.png",
  "운명의 파편": "Fragment_of_Fate.png",
  "명예의 파편": "Honor_Fragment.png",
  "위대한 명예의 돌파석": "Great_Honor_Breakstone.png",
  "정제된 수호강석": "Refined_Guardian_Stone.png",
  "정제된 파괴강석": "Refined_Destruction_Stone.png",
  "찬란한 명예의 돌파석": "Radiant_Breakthrough_Stone_of_Honor.png",
  "카르마의 잔영": "Shadow_of_Karma.png",
  "클리어 메달": "Clear_Medal.png",
  "융합 돌파석": "Fusion_Breakthrough_Stone.png",
  "베히모스의 비늘": "Behemoth_Scale.png",
  "몽환의 사념": "Dream_Thought.png",
  "마력의 샘물": "Mana_Spring.png",
  파괴강석: "Destruction_Stone.png",
  "파괴석 결정": "Destruction_Stone_Fragment.png",
  "혼돈의 돌": "Stone_of_Chaos.png",
  "낙뢰의 뿔": "Horn_of_Lightning.png",
  "우레의 뇌옥": "Prison_of_Thunder.png",
  "비호의 메달": "Medal_of_Protection.png",
  "수호의 메달": "Medal_of_Guardian.png",
};

export const getMaterialImagePath = (materialName: string): string | null => {
  const mappedName = materialNameMap[materialName];
  if (!mappedName) {
    console.warn(`Material name "${materialName}" not found in mapping.`);
    return null;
  }
  return `${process.env.PUBLIC_URL}/img/Material_Icon/${mappedName}`;
};

export const ClassIcon: Record<string, string> = {
  기상술사: "/img/ClassIcon/Aeromancer.png",
  아르카나: "/img/ClassIcon/Arcanist.png",
  블래스터: "/img/ClassIcon/Artillerist.png",
  도화가: "/img/ClassIcon/Artist.png",
  바드: "/img/ClassIcon/Bard.png",
  버서커: "/img/ClassIcon/Berserker.png",
  데빌헌터: "/img/ClassIcon/Deadeye.png",
  브레이커: "/img/ClassIcon/Breaker.png",
  블레이드: "/img/ClassIcon/DeathBlade.png",
  디스트로이어: "/img/ClassIcon/Destroyer.png",
  창술사: "/img/ClassIcon/Glaivier.png",
  워로드: "/img/ClassIcon/Gunlancer.png",
  건슬링어: "/img/ClassIcon/Gunslinger.png",
  스카우터: "/img/ClassIcon/Machinist.png",
  홀리나이트: "/img/ClassIcon/Paladin.png",
  리퍼: "/img/ClassIcon/Reaper.png",
  인파이터: "/img/ClassIcon/Scrapper.png",
  데모닉: "/img/ClassIcon/Shadowhunter.png",
  호크아이: "/img/ClassIcon/Sharpshooter.png",
  슬레이어: "/img/ClassIcon/Slayer.png",
  소서리스: "/img/ClassIcon/Sorceress.png",
  소울이터: "/img/ClassIcon/Souleater.png",
  기공사: "/img/ClassIcon/SoulFist.png",
  스트라이커: "/img/ClassIcon/Striker.png",
  서머너: "/img/ClassIcon/Summoner.png",
  배틀마스터: "/img/ClassIcon/Wardancer.png",
  환수사: "/img/ClassIcon/WildSoul.png",
};

export const ClassImage: Record<string, string> = {
  기상술사: "/img/ClassImage/Aeromancer.jpg",
  아르카나: "/img/ClassImage/Arcanist.jpg",
  블래스터: "/img/ClassImage/Artillerist.jpg",
  도화가: "/img/ClassImage/Artist.jpg",
  바드: "/img/ClassImage/Bard.jpg",
  버서커: "/img/ClassImage/Berserker.jpg",
  브레이커: "/img/ClassImage/Breaker.jpg",
  데빌헌터: "/img/ClassImage/Deadeye.jpg",
  블레이드: "/img/ClassImage/DeathBlade.jpg",
  디스트로이어: "/img/ClassImage/Destroyer.jpg",
  창술사: "/img/ClassImage/Glaivier.jpg",
  워로드: "/img/ClassImage/Gunlancer.jpg",
  건슬링어: "/img/ClassImage/Gunslinger.jpg",
  스카우터: "/img/ClassImage/Machinist.jpg",
  홀리나이트: "/img/ClassImage/Paladin.jpg",
  리퍼: "/img/ClassImage/Reaper.jpg",
  인파이터: "/img/ClassImage/Scrapper.jpg",
  데모닉: "/img/ClassImage/Shadowhunter.jpg",
  호크아이: "/img/ClassImage/Sharpshooter.jpg",
  슬레이어: "/img/ClassImage/Slayer.jpg",
  소서리스: "/img/ClassImage/Sorceress.jpg",
  소울이터: "/img/ClassImage/Souleater.jpg",
  기공사: "/img/ClassImage/SoulFist.jpg",
  스트라이커: "/img/ClassImage/Striker.jpg",
  서머너: "/img/ClassImage/Summoner.jpg",
  배틀마스터: "/img/ClassImage/Wardancer.jpg",
  환수사: "/img/ClassImage/WildSoul.jpg",
};
